// ---------------------------
// Empty link removal
// ---------------------------
$(document).ready(function() {
  $('a').each(function() {
    var linkText = $(this).text().trim();
    var linkHtml = $(this).html().trim();

    if (linkText === '' && linkHtml === '') {
      $(this).remove();
    }
  });

  $('.site-nav__link.site-nav__link--underline:not(.site-nav__link--has-dropdown) svg').remove();
  $('br').attr('aria-hidden','true');

  $(' h2, h3, h4, h5, h6').each(function () {
    if ($(this).text().trim() === '') {
      $(this).remove();
    }
  });

  setInterval(() => {
    $('.flickity-enabled.is-draggable.is-fade').removeAttr('tabindex','0');
  }, 500);
});

// ---------------------------
// Product slideshow tabindex fix
// ---------------------------
$(document).ready(function () {
  setInterval(() => {
    $('.product-slideshow').removeAttr('tabindex','0');
  }, 500);

  $('.noUi-handle.noUi-handle-lower').attr(
    'aria-label',
    'minimum price, after updation, the price will be increased by 10 and focus goes out of filters'
  );
  $('.noUi-handle.noUi-handle-upper').attr(
    'aria-label',
    'maximum price, after updation, the price will be decreased by 10 and focus goes out of filters'
  );
});

// ---------------------------
// External link warnings
// ---------------------------
document.querySelectorAll('a[href]').forEach(link => {
  const href = link.getAttribute('href')?.trim();

  if (!href) return;
  if (href.startsWith('mailto:') || href.startsWith('tel:')) return;

  try {
    const linkUrl = new URL(href, window.location.origin);
    const isExternal = linkUrl.origin !== window.location.origin;

    if (isExternal) {
      const label = link.getAttribute('title')?.trim() || link.textContent.trim();

      if (label && !link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', `${label} (opens in a new window)`);
      }

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  } catch (error) {
    return;
  }
});

// ---------------------------
// Mailto & Tel links labeling
// ---------------------------
document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]').forEach(link => {
  const href = link.getAttribute('href')?.trim();
  if (!href) return;

  const labelText = link.getAttribute('title')?.trim() || link.textContent.trim();
  const fallback = href.replace(/^mailto:|^tel:/, '');

  if (href.startsWith('mailto:') && !link.hasAttribute('aria-label')) {
    link.setAttribute('aria-label', `Email: ${labelText || fallback}`);
  }

  if (href.startsWith('tel:') && !link.hasAttribute('aria-label')) {
    link.setAttribute('aria-label', `Phone: ${labelText || fallback}`);
  }
});

// =====================================================================
//  ADDED FIXED DROPDOWN MENU CODE (working on iPad/tablets)
// =====================================================================
$(document).ready(function() {
  let hoverTimeout = null;
  let lastTrigger = null;

  // Robust detection for iPadOS, tablets, touch Macs
  let isTouchDevice =
    (('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0));

  if (
    navigator.userAgent.includes("iPad") ||
    (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1)
  ) {
    isTouchDevice = true;
  }

  // Add ARIA attributes
  $('.site-nav__link--has-dropdown').each(function() {
    $(this).attr({
      'aria-haspopup': 'true',
      'aria-expanded': 'false'
    });
  });

  // ---------------------------
  // DESKTOP HOVER LOGIC
  // ---------------------------
  if (!isTouchDevice && window.matchMedia('(min-width:1025px)').matches) {
    $('.site-nav__item.site-nav--has-dropdown').hover(
      function() {
        clearTimeout(hoverTimeout);
        const $item = $(this);

        $('.site-nav__item').removeClass('is-focused is-hovered');
        $('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');

        $item.addClass('is-hovered');
        $item.find('.site-nav__link--has-dropdown').attr('aria-expanded', 'true');
      },
      function() {
        const $item = $(this);
        hoverTimeout = setTimeout(() => {
          $item.removeClass('is-hovered');
          $item.find('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
        }, 300);
      }
    );

    $('.site-nav__dropdown, .megamenu').hover(
      () => clearTimeout(hoverTimeout),
      function() {
        const $item = $(this).closest('.site-nav__item');
        $item.removeClass('is-hovered');
        $item.find('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
      }
    );
  }

  // ---------------------------
  // HELPERS
  // ---------------------------
  function openDropdown($trigger) {
    const $parent = $trigger.closest('.site-nav__item');

    $('.site-nav__item').removeClass('is-focused is-hovered');
    $('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');

    $parent.addClass('is-focused');
    $trigger.attr('aria-expanded', 'true');
    lastTrigger = $trigger;
  }

  function closeAll() {
    $('.site-nav__item').removeClass('is-focused is-hovered');
    $('.site-nav__link--has-dropdown').attr('aria-expanded', 'false');
  }

  // ---------------------------
  // CLICK & TOUCH DROPDOWN LOGIC (iPad Fix)
  // ---------------------------
  $(document).on('click touchstart', '.site-nav__link--has-dropdown', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $trigger = $(this);
    const expanded = $trigger.attr('aria-expanded') === 'true';

    if (expanded) {
      closeAll();
    } else {
      openDropdown($trigger);
    }
  });

  // Keyboard:
  $(document).on('keydown', '.site-nav__link--has-dropdown', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.which === 13 || e.which === 32) {
      e.preventDefault();
      e.stopPropagation();
      openDropdown($(this));
    }
  });

  // Close when clicking outside
  $(document).on('click touchstart', function(e) {
    if (!$(e.target).closest('.site-nav__item').length) {
      closeAll();
    }
  });

  // ESC closes dropdown
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeAll();
      if (lastTrigger) lastTrigger.focus();
    }
  });
});


// ---------------------------
// Country Selector
// ---------------------------
$(document).ready(function () {
  var $switcher = $('.plus-store-switcher');
  var $toggle = $switcher.find('.plus-store-switcher__toggle, [data-dropdown-toggle]');
  var $content = $switcher.find('[data-dropdown-content]');

  function setExpanded(isOpen) {
    $toggle.attr('aria-expanded', isOpen);
    $content.attr('aria-hidden', !isOpen);
  }

  $(document).on('click', function (e) {
    var $target = $(e.target);
    var $inSwitcher = $target.closest('.plus-store-switcher');
    var $clickedToggle = $target.closest('.plus-store-switcher__toggle, [data-dropdown-toggle]');

    if ($clickedToggle.length) {
      var willOpen = !$switcher.hasClass('site-nav--active-dropdown');
      $switcher.toggleClass('site-nav--active-dropdown', willOpen);
      setExpanded(willOpen);
    } else if (!$inSwitcher.length) {
      if ($switcher.hasClass('site-nav--active-dropdown')) {
        $switcher.removeClass('site-nav--active-dropdown');
        setExpanded(false);
      }
    }
  });

  $toggle.on('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      var willOpen = !$switcher.hasClass('site-nav--active-dropdown');
      $switcher.toggleClass('site-nav--active-dropdown', willOpen);
      setExpanded(willOpen);
    }
  });
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    const switcher = document.querySelector('.plus-store-switcher.site-nav--active-dropdown');
    if (!switcher) return;
    const toggle = switcher.querySelector('.plus-store-switcher__toggle, [data-dropdown-toggle]');
    const content = switcher.querySelector('[data-dropdown-content]');
    switcher.classList.remove('site-nav--active-dropdown');
    toggle.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    toggle.focus();
  }
});

// ---------------------------
// Popup video logic
// ---------------------------
let lastFocusedElement = null;
let focusableElements = [];

function openPopup(videoSrc) {
  const popup = document.getElementById("videoPopup");
  const popupIframe = document.getElementById("popupIframe");
  if (!popup || !popupIframe) return;

  lastFocusedElement = document.activeElement;

  popup.style.display = "flex";
  popup.setAttribute('aria-hidden', 'false');

  popupIframe.src = videoSrc;

  focusableElements = Array.from(popup.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  ));

  if (focusableElements.length > 0) {
    setTimeout(() => focusableElements[0].focus(), 50);
  }

  document.addEventListener('keydown', handlePopupKeys);
  popupIframe.setAttribute('tabindex', '-1');
}

function closePopup() {
  const popup = document.getElementById("videoPopup");
  const popupIframe = document.getElementById("popupIframe");
  if (!popup || !popupIframe) return;

  popup.style.display = "none";
  popup.setAttribute('aria-hidden', 'true');

  popupIframe.src = '';

  if (lastFocusedElement) {
    lastFocusedElement.focus();
  }

  document.removeEventListener('keydown', handlePopupKeys);
}

function handlePopupKeys(event) {
  const popup = document.getElementById("videoPopup");
  if (!popup) return;
  if (popup.style.display !== "flex") return;

  if (event.key === 'Escape') {
    closePopup();
    event.preventDefault();
    return;
  }

  if (event.key === 'Tab') {
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        lastElement.focus();
        event.preventDefault();
      }
    } else {
      if (document.activeElement === lastElement) {
        firstElement.focus();
        event.preventDefault();
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById("videoPopup");
  if (!popup) return;
  popup.style.display = "none";
  popup.setAttribute('role', 'dialog');
  popup.setAttribute('aria-modal', 'true');

  popup.addEventListener('click', function(event) {
    if (event.target === this) {
      closePopup();
    }
  });
});

// ---------------------------
// Iframe "missing title" fixes
// ---------------------------
$(document).ready(function() {
  $('iframe:not([title])').each(function() {
    var $iframe = $(this);
    var src = $iframe.attr('src') || '';

    if (src.includes('youtube.com') || src.includes('youtu.be')) {
      $iframe.attr('title', 'YouTube video');
    } else if (src.includes('vimeo.com')) {
      $iframe.attr('title', 'Vimeo video');
    } else if (src.includes('maps.google.com') || src.includes('google.com/maps')) {
      $iframe.attr('title', 'Google Map');
    } else if (src.includes('player.soundcloud.com')) {
      $iframe.attr('title', 'SoundCloud audio player');
    } else if (src.includes('facebook.com')) {
      $iframe.attr('title', 'Facebook embedded content');
    } else {
      $iframe.attr('title', 'Embedded content');
    }
  });
});